import * as signalR from "@microsoft/signalr";

/**
 * Cria, inicia e configura uma conexão SignalR, retornando o connectionId.
 * @param {function} onProgress - Callback para atualizações de progresso (progress, message).
 * @param {function} onError - Callback para erros.
 * @returns {Promise<{connection: object, connectionId: string}|null>} Um objeto com a conexão e o ID, ou nulo em caso de falha.
 */
const establishConnection = async (onProgress, onError) => {
    const connection = new signalR.HubConnectionBuilder()
      .withUrl(`${process.env.REACT_APP_BASE_ROUTE.replace('/api/', '')}/loadingProgressHub`)
      .withAutomaticReconnect()
      .build();

    connection.on("ReceiveProgress", onProgress);
    connection.on("ReceiveError", onError);

    try {
        await connection.start();
        return { connection, connectionId: connection.connectionId };
    } catch (err) {
        console.error('SignalR Connection Error: ', err);
        return null;
    }
};

/**
 * Para e descarta uma conexão SignalR de forma segura.
 * @param {object} connection - A instância da conexão a ser parada.
 */
const stopConnection = (connection) => {
    if (connection) {
        connection.stop();
    }
};

export const signalRService = {
    establishConnection,
    stopConnection
};